var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1 13H13V3.9C13 3.12 12.48 2.6 11.7 2.6C5.2 2.6 0 7.8 0 14.3C0 20.8 5.2 26 11.7 26C18.2 26 23.4 20.8 23.4 14.3C23.4 13.52 22.88 13 22.1 13ZM13 23.27C8.06 24.05 3.38 20.54 2.73 15.6C1.95 10.66 5.46 5.98 10.4 5.33V14.3C10.4 15.08 10.92 15.6 11.7 15.6H20.67C20.15 19.63 17.03 22.75 13 23.27ZM16.9 0C16.12 0 15.6 0.52 15.6 1.3V9.1C15.6 9.88 16.12 10.4 16.9 10.4H24.7C25.48 10.4 26 9.88 26 9.1C26 4.03 21.97 0 16.9 0ZM18.2 7.8V2.73C20.8 3.25 22.75 5.2 23.27 7.8H18.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.f1cbfedb52a6f5bea09455bb6ae8ece6.svg";
export { ForwardRef as ReactComponent };